import { render, staticRenderFns } from "./layout-info-content-window.vue?vue&type=template&id=5447a5b9&scoped=true&"
import script from "./layout-info-content-window.vue?vue&type=script&lang=js&"
export * from "./layout-info-content-window.vue?vue&type=script&lang=js&"
import style0 from "./layout-info-content-window.vue?vue&type=style&index=0&id=5447a5b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447a5b9",
  null
  
)

export default component.exports